<template>
  <div class="widget-unavailable flex-1">
    <div class="widget-wrapper">
      <div class="widget-common widget-small widget-full-height demo-widget">
        <div class="widget-title d-flex align-items-baseline">
          Focus Time
          <i
            v-tooltip="tooltipOptions"
            class="hi hi-info-filled ml-5"
            :title="tooltip"
          ></i>
        </div>
        <div class="widget-body">
          <div class="widget-details insights-focus-time-widget-content d-flex position-relative mb-20">
            <div
              class="chart-wrapper d-flex flex-column align-items-center align-self-start justify-content-center mb-10"
            >
              <AppChartDonut
                :values="[{ key: 'demo-focus-time', value: 100 }]"
                :size="70"
                :inner-radius="28"
                text="?"
                sort
              />
            </div>
            <div class="chart-legend mb-10">Learn about distractions keeping your team from completing tasks</div>
          </div>
        </div>
        <div
          v-if="insightsUrl"
          class="mt-auto"
        >
          <a
            class="btn btn-sm btn-primary"
            :href="insightsUrl"
          >
            Find out more
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { INSIGHTS } from '~/app_constants';
import AppChartDonut from '~/components/AppChartDonut.vue';
import { mapState } from 'vuex';

export default {
  name: 'ActivitiesBenchmarksInsightsFocusTimeDemo',
  components: {
    AppChartDonut,
  },
  props: {
    insightsUrl: {
      type: String,
      required: false,
    },
  },
  data: () => ({
    widgetTooltipOptions: Object.freeze({ html: true, sanitize: false }),
  }),
  computed: {
    ...mapState(['organization']),
    widget() {
      return 'focusTime';
    },
    tooltipOptions() {
      const template = INSIGHTS.tooltips[this.widget]?.template;

      if (!template) {
        return this.widgetTooltipOptions;
      }

      return {
        ...this.widgetTooltipOptions,
        template,
      };
    },
    tooltip() {
      return INSIGHTS.tooltips[this.widget]?.content;
    },
  },
};
</script>
